import { useSecuritiesContext } from '@talos/kyoko';
import { useMemo } from 'react';
import { of } from 'rxjs';

export function usePriceGridSourceObservable() {
  const { securitiesListSortedByRank } = useSecuritiesContext();

  return useMemo(
    () =>
      of({
        initial: true,
        data: securitiesListSortedByRank.map(security => ({ security })),
      }),
    [securitiesListSortedByRank]
  );
}
